<template>
    <div class="text-input">
        <input
            :id="name"
            :type="type"
            :name="name"
            :aria-label="label"
            :placeholder="label"
            :value="value"
            class="text-input__input"
            @input="emitValue"
        />
        <label :for="name" class="text-input__label"></label>
    </div>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: 'text'
        },
        name: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        },
        value: {
            type: String,
            default: ''
        }
    },

    methods: {
        emitValue(event) {
            this.$emit('input', event.target.value);
        }
    }
};
</script>

<style lang="scss">
.text-input__input {
    width: 100%;
    padding: 5px 14px;
    border: none;
    font-style: italic;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
}
</style>
